export default __webpack_public_path__ + "static/loading-animation-71b2c446c852afc8a402a2d87a7cddce.png";